import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import queryString from 'query-string';
import ReactMarkdown from 'react-markdown';
import {
	isEqual, isEmpty, cloneDeep, forEach, isNull, isUndefined, get, pick,
} from 'lodash';
import { Loader, SubNavBar } from '@components/common';
import classNames from 'classnames';
import utils, { constants } from '@utils';
import Actions, { thunks } from '@redux/payments';
import { CollapseItem } from '@components';
import {
	DetailItem, InvoiceBreakDownTable, PaymentActionButtons, ScheduledClockedTime, DisputeFormModal,
} from './components';

class PaymentsView extends Component {
	constructor(props) {
		super(props);
		const { details } = this.props;
		this.state = {
			detailsData : this.getFormattedData(details) || {},
		};
	}

	componentDidMount() {
		const { getInvoiceData, updateStoreProperties, invoiceId } = this.props;
		getInvoiceData(invoiceId);
		updateStoreProperties({ activeDisputeId : invoiceId, activeInvoiceIds : [invoiceId] });
	}

	UNSAFE_componentWillReceiveProps = ({ details }) => {
		const lastProps = this.props;
		if (!isEqual(lastProps.details, details)) this.setState({ detailsData : this.getFormattedData(details) });
	}

	changeCollapseStatus = (id, value) => {
		const { collapse, updateStoreProperties } = this.props;
		const newCollapseObj = cloneDeep(collapse);
		newCollapseObj[id] = value;
		updateStoreProperties({ collapse : newCollapseObj });
	}

	getFormattedData = (rawData) => {
		const {
			StatusId,
			Status,
			JobRate,
			JobLocation,
			Officer,
			Coordinator,
			Items,
			CoordinatorFees,
			TotalOfficerPay,
			TotalCoordinatorFee,
			TotalServiceCharge,
			TotalInvoice,
			Notes,
			Attachments,
			StatusHistory,
			JobStartDateTime,
			JobEndDateTime,
			Tax,
			DisputeReason,
			ClockInDateTime,
			ClockOutDateTime,
		} = rawData;
		const returnData = {
			statusObj : utils.getJobStatusFromStatusId(StatusId, Status),
		};
		const { location : { search } } = this.props;
		const TimeZoneId = get(this.props, ['user', 'TimeZoneId'], 'America/Chicago');
		const { type } = queryString.parse(search);
		if (type === 'disputes' && !isEmpty(DisputeReason)) {
			returnData.disputeData = [
				{
					firstItem : true,
					label     : 'Disputed By',
					value     : DisputeReason.DisputedByUserFullName,
				},
				{
					label : 'Reason',
					value : DisputeReason.ReasonName,
				},
				{
					label : 'Note',
					value : DisputeReason.Note,
				},
			];
		}
		returnData.detailItems = [
			{
				firstItem : true,
				label     : 'Rate',
				value     : `$${JobRate}/hour`,
			},
			{
				label : 'Location',
				value : JobLocation,
			},
			{
				label : 'Date',
				value : utils.parseUTCDateToTimeZone(JobStartDateTime, TimeZoneId).format('dddd, MMMM D, YYYY'),
			},
			{
				label        : 'Officer',
				imageUrl     : Officer ? Officer.ImageURL || '' : '',
				name         : Officer ? Officer.Name || '' : '',
				shortAddress : Officer ? utils.constructShortAddress(Officer.City, Officer.StateName) : '',
			},
			{
				label        : 'Coordinators',
				imageUrl     : Coordinator ? Coordinator.ImageURL || '' : '',
				name         : Coordinator ? Coordinator.Name || '' : '',
				shortAddress : Coordinator ? utils.constructShortAddress(Coordinator.City, Coordinator.StateName) : '',
			},
		];
		returnData.scheduledClockData = [
			{
				header : 'Scheduled Time',
				data   : [
					{ id : 1, label : 'Scheduled/Start', value : utils.parseUTCDateToTimeZone(JobStartDateTime, TimeZoneId).format('h:mm A') },
					{ id : 2, label : 'Scheduled/End', value : utils.parseUTCDateToTimeZone(JobEndDateTime, TimeZoneId).format('h:mm A') },
				],
			},
			{
				header         : 'Clock-In/Out',
				outerClassName : 'margin-left-40',
				data           : [
					{
						id    : 3,
						label : 'Clock-In',
						value : ClockInDateTime
							? utils.parseUTCDateToTimeZone(ClockInDateTime, TimeZoneId).format('h:mm A')
							: 'No clock in',
					},
					{
						id    : 4,
						label : 'Clock-Out',
						value : ClockOutDateTime
							? utils.parseUTCDateToTimeZone(ClockOutDateTime, TimeZoneId).format('h:mm A')
							: 'No clock out',
					},
				],
			},
		];
		returnData.tableData = [];
		if (!isUndefined(Items) && !isNull(Items) && Items.length) {
			forEach(Items, (items) => {
				returnData.tableData.push({
					rowId       : items.Id,
					description : items.ItemName,
					rate        : items.Price,
					quantity    : items.Quantity,
					total       : items.Total,
					clockIn     : items.ClockIn ? utils.parseUTCDateToTimeZone(items.ClockIn, TimeZoneId).format('h:mm A') : '',
					clockOut    : items.ClockOut ? utils.parseUTCDateToTimeZone(items.ClockOut, TimeZoneId).format('h:mm A') : '',
				});
			});
			returnData.tableData.push({
				rowId : 'officers_total',
				type  : 'total',
				label : 'Total Officers Pay',
				total : TotalOfficerPay,
			});
		}
		if (!isUndefined(CoordinatorFees) && !isNull(CoordinatorFees) && !isEmpty(CoordinatorFees)) {
			const { Price, Quantity, Total } = CoordinatorFees;
			const { Name, ImageURL } = Coordinator;
			returnData.tableData.push({
				rowId            : 'coordinator_1',
				name             : Name,
				image            : ImageURL,
				rate             : Price,
				quantity         : Quantity,
				total            : Total,
				firstCoordinator : true,
			});
			returnData.tableData.push({
				rowId : 'coordinators_total',
				type  : 'total',
				label : 'Total Coordinators Pay',
				total : TotalCoordinatorFee,
			});
		}
		returnData.tableData.push({
			rowId : 'rkPay_fees',
			type  : 'total',
			label : 'RKPay Fees',
			total : TotalServiceCharge,
		},
		{
			rowId : 'rkPay_tax',
			type  : 'total',
			label : 'Tax',
			total : Tax,
		},
		{
			rowId : 'invoice_total',
			type  : 'total',
			label : 'TOTAL',
			total : TotalInvoice,
		});
		returnData.notesData = [];
		if (!isUndefined(Notes) && !isNull(Notes) && Notes.length) {
			forEach(Notes, (item) => {
				returnData.notesData.push({
					id    : item.Id,
					title : `${item.UserName} added a note`,
					date  : utils.parseUTCDateToTimeZone(item.CreateDateUTC, TimeZoneId).fromNow(),
					note  : item.Note,
				});
			});
		}
		returnData.attachmentData = [];
		returnData.attachmentDownloadAllUrl = [];
		if (!isUndefined(Attachments) && !isNull(Attachments) && Attachments.length) {
			forEach(Attachments, (item) => {
				returnData.attachmentData.push({
					id       : item.Id,
					title    : item.FileName,
					date     : utils.parseUTCDateToTimeZone(item.CreateDateUTC, TimeZoneId).fromNow(),
					url      : item.AttachmentUrl,
					userName : item.UserName,
				});
				returnData.attachmentDownloadAllUrl.push({ fileName : item.FileName, url : item.AttachmentUrl });
			});
		}
		returnData.statusHistoryData = [];
		if (!isUndefined(StatusHistory) && !isNull(StatusHistory) && StatusHistory.length) {
			returnData.statusHistoryData = utils.formatStatusHistoryData(StatusHistory, TimeZoneId);
		}
		return returnData;
	}

	buttonClicked = (action) => () => {
		const {
			callStatusChangedApi,
			updateStoreProperties,
			invoiceStatusChanged,
			push,
			updateModalState,
			invoiceId,
			details : {
				TransactionId,
				InvoiceEstimatePrePayment,
			},
		} = this.props;
		if (action === 'paid') push({ pathname : `/payments/receipt/${TransactionId}` });
		else if (action === 'dispute') updateModalState('disputeForm', true);
		else if (action === 'payInvoice') {
			updateStoreProperties({ activeInvoiceIds : [invoiceId] });
			push({ pathname : '/payments/invoice' });
		} else if (action === 'toReview') {
			callStatusChangedApi({ idArray : [invoiceId], status : 3, viewType : 'review' });
		} else {
			invoiceStatusChanged({
				type : action, id : invoiceId, viewType : this.getDetailType(), isPrepaid : InvoiceEstimatePrePayment,
			});
		}
	}

	getDetailType = () => {
		const { details } = this.props;
		let type = '';
		if (details.StatusId === constants.INVOICE_STATUSES.CREATED) type = 'submission';
		else if (
			details.StatusId === constants.INVOICE_STATUSES.PENDING_REVIEW
			|| details.StatusId === constants.INVOICE_STATUSES.PENDING_CLIENT_REVIEW
			|| details.StatusId === constants.INVOICE_STATUSES.AMENDED
		) type = 'review';
		else if (
			details.StatusId === constants.INVOICE_STATUSES.PENDING_PAYMENT
			|| details.StatusId === constants.INVOICE_STATUSES.PAYMENT_REJECTED
		) type = 'payment';
		else if (details.StatusId === constants.INVOICE_STATUSES.DISPUTED) type = 'dispute';
		else if (
			details.StatusId === constants.INVOICE_STATUSES.PENDING_PROCESSING
			|| details.StatusId === constants.INVOICE_STATUSES.PAID
			|| details.StatusId === constants.INVOICE_STATUSES.DEPOSITED
			|| details.StatusId === constants.INVOICE_STATUSES.DEPOSIT_FAILED
		) type = 'paid';
		return type;
	}

	onClickBackToInvoices = (event) => {
		event.preventDefault();

		const { history : { push } } = this.props;
		push('/payments');
	}

	renderJobDetails = (jobDetailsArray) => (
		<For
			each="item"
			of={jobDetailsArray}
		>
			<DetailItem
				key={item.label}
				firstItem={item.firstItem}
				label={item.label}
				value={item.value}
				imageUrl={item.imageUrl}
				name={item.name}
				shortAddress={item.shortAddress}
			/>
		</For>
	)

	render() {
		const {
			collapse, location : { search }, loading, details, activeDisputeId, user,
		} = this.props;
		const { detailsData } = this.state;
		const {
			Id,
			JobEventId,
			JobTitle,
			JobDetails,
			AssignmentId,
			TotalInvoice,
			EstimatedInvoiceTotal,
			TransactionId,
			InvoiceEstimatePrePayment,
		} = details;
		const {
			statusObj,
			detailItems,
			scheduledClockData,
			notesData,
			attachmentData,
			attachmentDownloadAllUrl,
			statusHistoryData,
		} = detailsData;
		const type = this.getDetailType();
		const { fromReports } = queryString.parse(search);

		if (loading.details || loading.status || isEmpty(detailsData)) return <Loader active />;
		return (
			<Fragment>
				<div className="hidden-print">
					<SubNavBar
						backText={`Back ${fromReports ? '' : 'to invoice list'}`}
						backButton
						onClickBack={this.onClickBackToInvoices}
					/>
				</div>
				<Grid className="margin-top-50">
					<div className="row-eq-height">
						<Col
							md={8}
							className="bg-white padding-0 rating-data"
						>
							<div className="bg-gray-12">
								<div className="invoice-details-div padding-top-20 padding-bottom-20">
									<Row>
										<Col md={6}>
											<span className={`label label-${statusObj.label} font-size-10`}>{ statusObj.value }</span>
											{InvoiceEstimatePrePayment === true && (
												<span
													className="tag tag-success margin-left-5"
													title="This job has been prepaid, no overtime hours are allowed."
												>
													Prepaid
												</span>
											)}
										</Col>
										<Col md={6} className="text-right">
											<Link to={`/jobs/${JobEventId}`} className="hidden-print">
												Job ID :
												{' '}
												{ JobEventId }
											</Link>
											<br />
											Invoice #:
											{' '}
											{ Id }
											<br />
											Assignment #:
											{' '}
											{ AssignmentId }
											<If condition={type === 'paid'}>
												<span className={classNames('margin-bottom--30', { hidden : !TransactionId })}>
													Transaction ID :
													{ TransactionId }
												</span>
											</If>
										</Col>
									</Row>
									<Row>
										<Col
											md={12}
											className="margin-bottom-10"
										>
											<span className="font-size-25 font-regular color-gray-deep-cove">{ JobTitle }</span>
										</Col>
										<Col
											md={12}
										>
											<ReactMarkdown
												className="font-size-14 font-regular color-gray-cloud-burst"
												source={JobDetails}
											/>
										</Col>
									</Row>
								</div>
							</div>
							<div className="margin-0 separator" />
							<If condition={type === 'disputes'}>
								<div className="invoice-details-div padding-top-20 padding-bottom-20">
									<span className="font-size-25 font-regular color-gray-deep-cove padding-bottom-20">Dispute Details</span>
									{ this.renderJobDetails(detailsData.disputeData || []) }
								</div>
								<div className="separator" />
							</If>
							<div className="invoice-details-div padding-top-20 padding-bottom-20">
								<span className="font-size-25 font-regular color-gray-deep-cove padding-bottom-20">Job Details</span>
								{ this.renderJobDetails(detailItems) }
							</div>
							<div className="separator" />
							<InvoiceBreakDownTable invoice={details} timeZoneId={user.TimeZoneId} />
							<div className="separator" />
							<PaymentActionButtons
								type={type}
								user={user}
								className="padding-top-20 padding-bottom-100 hidden-print"
								hasTransactionId={TransactionId !== null && TransactionId !== undefined}
								buttonClicked={this.buttonClicked}
							/>
						</Col>
						<Col
							md={4}
							className="bg-gray-12 padding-top-20 padding-bottom-20 hidden-print margin-top-10-mob"
						>
							<div className="flex flex-center flex-direction-column">
								<span className="font-size-18 font-regular color-dark">TOTAL INVOICE</span>
								<span className="font-size-35 font-regular color-dark margin-top-20">
									{ utils.currencyFormatter(TotalInvoice || 0) }
									{' '}
									USD
								</span>
								<span className={classNames('font-size-16 font-regular',
									{
										'color-pink-brink' : TotalInvoice > EstimatedInvoiceTotal,
										'color-gray-dove'  : TotalInvoice <= EstimatedInvoiceTotal,
									})}
								>
									(Est. Invoice :
									{ utils.currencyFormatter(EstimatedInvoiceTotal || 0) }
									{' '}
									USD)
								</span>
							</div>
							<PaymentActionButtons
								type={type}
								user={user}
								className="margin-top-20 margin-bottom-20"
								hasTransactionId={TransactionId !== null && TransactionId !== undefined}
								buttonClicked={this.buttonClicked}
							/>
							<ScheduledClockedTime data={scheduledClockData} />
							<div className="separator" />
							<CollapseItem
								id="notes"
								title={`Notes (${notesData.length})`}
								data={notesData}
								collapse={collapse.notes}
								changeCollapseStatus={this.changeCollapseStatus}
								panelClassName="status-history-scroll"
							/>
							<CollapseItem
								id="attachments"
								title={`Attachments (${attachmentData.length})`}
								data={attachmentData}
								downloadAllArray={attachmentDownloadAllUrl}
								collapse={collapse.attachments}
								changeCollapseStatus={this.changeCollapseStatus}
								panelClassName="status-history-scroll"
							/>
							<CollapseItem
								id="statusHistory"
								title="Status History"
								data={statusHistoryData}
								collapse={collapse.statusHistory}
								changeCollapseStatus={this.changeCollapseStatus}
								panelClassName="status-history-scroll"
							/>
						</Col>
					</div>
				</Grid>
				<DisputeFormModal
					invoiceId={activeDisputeId}
					fromDetails
				/>
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	router : {
		match : {
			params : { id : invoiceId },
		},
	},
	payments : {
		details,
		loading,
		collapse,
		activeDisputeId,
		disputeConfirmation,
	},
	app: {
		user,
	},
}) => ({
	invoiceId,
	details,
	loading,
	collapse,
	activeDisputeId,
	disputeConfirmation,
	user,
});

const mapDispatchToProps = (dispatch) => ({
	updateStoreProperties : bindActionCreators(Actions, dispatch).updateStoreProperties,
	updateModalState      : bindActionCreators(Actions, dispatch).updateModalState,
	push                  : bindActionCreators(pushAction, dispatch),
	...pick(bindActionCreators(thunks, dispatch), ['getInvoiceData', 'invoiceStatusChanged', 'callStatusChangedApi']),
});

PaymentsView.propTypes = {
	activeDisputeId : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	callStatusChangedApi : PropTypes.func.isRequired,
	collapse             : PropTypes.object,
	details              : PropTypes.object,
	getInvoiceData       : PropTypes.func.isRequired,
	history              : PropTypes.object,
	invoiceId            : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	invoiceStatusChanged  : PropTypes.func.isRequired,
	loading               : PropTypes.object,
	push                  : PropTypes.func.isRequired,
	updateModalState      : PropTypes.func.isRequired,
	updateStoreProperties : PropTypes.func.isRequired,
	user                  : PropTypes.object,
	location              : PropTypes.object.isRequired,
};

PaymentsView.defaultProps = {
	activeDisputeId : '',
	collapse        : {},
	details         : {},
	history         : {},
	invoiceId       : '',
	loading         : {},
	user            : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentsView);
